/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * String field representation.
 */
export interface StringClaimValue {
    /** The string field value. */
    value: string;
}
